import DownloadMantel from './DownloadMantel'

export default DownloadMantel